import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND } from '../lib/brand';

function LegalFooter() {
  return (
    <footer className="legal-footer">
      <div className="legal-footer-inner">
        <div className="legal-footer-brand">
          <span className="legal-footer-title">StockVested</span>
          <p className="legal-footer-copy">
            Research, journaling, and performance review tools for traders and investors
          </p>
        </div>

        <nav className="legal-footer-links" aria-label="Legal links">
          <Link to="/onboarding">Onboarding</Link>
          <Link to="/feedback">Feedback</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/risk-disclaimer">Risk Disclaimer</Link>
          <Link to="/billing-terms">Subscription & Billing Terms</Link>
        </nav>
      </div>
    </footer>
  );
}

export default LegalFooter;